import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { PAGINATED_SCHEMA_FIELDS } from './../basics/paginated.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the categories component form.
 * Defines the fields to display for the form.
 */

export const CATEGORIES_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'children',
      label: 'components.categories.schema.showSubcategories',
      type: 'checkbox',
      default: false
    },
    ...PAGINATED_SCHEMA_FIELDS
  ]
};
